import React from 'react';
// material
import { Stack, Container, Typography, Card, Box } from '@mui/material';
// components
import Page from '../../components/Page';

export default function PageSettingsGeneral() {
  return (
    <Page title="General" path="/settings/general">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4">General Settings</Typography>
        </Stack>
        <Card>
          <Box sx={{ p: 3 }} />
        </Card>
      </Container>
    </Page>
  );
}
